<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("orderScheduler", ["setProfessionalName"]),

    selectedProfessionalName(event) {
      this.setProfessionalName(event.target.value);
    }
  },

  computed: {
    ...mapGetters("orderScheduler", ["professionalName"])
  },

  mounted() {
    this.$refs.input.focus();
  }
};
</script>

<template>
  <input
    ref="input"
    :class="{ 'input-text': professionalName }"
    type="text"
    placeholder="Quem você está procurando?"
    @input="selectedProfessionalName"
    :value="professionalName"
  />
</template>

<style scoped>
input {
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  padding: 0;
  min-height: unset;
  line-height: 24px;
  color: #424242;
  text-align: center;
}

input::placeholder {
  color: #666;
}

.input-text {
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalFilters/NameInput.vue